import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card custom-shadow rounded-3 bg-white border mb-4 custom-padding-30 position-relative" }
const _hoisted_2 = { style: {"margin":"-29px -27px -28px -16px"} }
const _hoisted_3 = {
  class: "position-absolute position-for-mobile",
  style: {"top":"92px","right":"30px"}
}
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { style: {"margin":"0 0 0 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SalesByGenderChart = _resolveComponent("SalesByGenderChart")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", {
      class: "d-flex justify-content-between align-items-center flex-wrap gap-3 position-relative pb-4",
      style: {"top":"-5px"}
    }, [
      _createElementVNode("h3", { class: "mb-0 fs-18 fw-semibold" }, "Listener Analytics"),
      _createElementVNode("div", {
        class: "dropdown select-dropdown without-border position-relative",
        style: {"right":"-5px"}
      }, [
        _createElementVNode("button", {
          class: "dropdown-toggle bg-transparent border text-body rounded-2",
          style: {"padding-right":"20px"},
          role: "button",
          "data-bs-toggle": "dropdown",
          "aria-expanded": "false"
        }, " Last 28 days "),
        _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }, [
          _createElementVNode("li", null, [
            _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last 28 days ")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last 48 days ")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last 90 days ")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Year ")
          ])
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SalesByGenderChart)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.isClient)
            ? (_openBlock(), _createBlock(_component_apexchart, {
                key: 0,
                type: "donut",
                height: "60",
                options: _ctx.listenerAnalytics,
                series: _ctx.analytics
              }, null, 8, ["options", "series"]))
            : _createCommentVNode("", true)
        ]),
        _cache[0] || (_cache[0] = _createStaticVNode("<ul class=\"ps-0 mb-0 list-unstyled last-child-none\" style=\"margin-left:-110px;\"><li class=\"d-flex align-items-center mb-2\"><span class=\"d-inline-block bg-primary-div rounded-circle\" style=\"width:10px;height:10px;margin-right:7px;\"></span><span class=\"fs-12 text-secondary\"> Men: <span class=\"fw-medium\">75%</span></span></li><li class=\"d-flex align-items-center\"><span class=\"d-inline-block bg-card-bg-c rounded-circle\" style=\"width:10px;height:10px;margin-right:7px;\"></span><span class=\"fs-12 text-secondary\"> Woman: <span class=\"fw-medium\">25%</span></span></li></ul>", 1))
      ])
    ])
  ]))
}